import React, { useState } from "react";
import { PieChart, Pie, Cell } from "recharts";
import "./practiceAreas.css";
import { getPracticeAreaLabel } from "../../../helpers/stringHelper";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineContent,
} from "@mui/lab";

const COLORS = [
  "#144A8C",
  "#2EB8BD",
  "#3881FE",
  "#4DA1E0", // Additional color 1
  "#6BBFF5", // Additional color 2
  "#95D1FF", // Additional color 3
];

const PracticeAreas = ({ practiceAreasData }) => {
  // Safely convert the incoming object to an array of [key, value] pairs.
  const practiceAreaEntries = practiceAreasData
    ? Object.entries(practiceAreasData)
    : [];

  // State to handle "read more / read less" toggles.
  const [expanded, setExpanded] = useState({});

  const toggleExpand = (areaName) => {
    setExpanded((prev) => ({ ...prev, [areaName]: !prev[areaName] }));
  };

  return (
    <div className="practice-areas-container-practice-area">
      <h2 className="practice-areas-title-practice-area">Practice Areas:</h2>
      <div className="practice-area-row-container">
        {practiceAreaEntries.length > 0 && (
          <div className="practice-areas-donut-container-practice-area">
            <PieChart width={350} height={350}>
              <Pie
                data={practiceAreaEntries.map(([areaName, details]) => ({
                  name: areaName,
                  value: parseFloat(details.percentage),
                }))}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                innerRadius={80} // Creates the donut hole.
                outerRadius={150}
                fill="#144A8C"
                labelLine={false}
              >
                {practiceAreaEntries.map(([areaName, details], index) => (
                  <Cell
                    key={`cell-${areaName}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>

              {/* Center text displaying the number of practice areas with a conditional label */}
              <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dominantBaseline="middle"
                className="practice-areas-center-text-practice-area"
              >
                {practiceAreaEntries.length}
                <tspan x="50%" dy="2em" className="practice-areas-inner-text">
                  {practiceAreaEntries.length === 1
                    ? "Practice Area"
                    : "Practice Areas"}
                </tspan>
              </text>
            </PieChart>
          </div>
        )}

        <div className="practice-areas-list-practice-area">
          {practiceAreaEntries.length > 0 ? (
            practiceAreaEntries.map(([areaName, details]) => {
              const isExpanded = expanded[areaName];
              const shortDescription =
                details.description.slice(0, 100) + "...";
              return (
                <div
                  className="practice-area-item-practice-area"
                  key={areaName}
                >
                  <div className="practice-area-header-practice-area">
                    <h3 className="practice-area-title-practice-area">
                      {getPracticeAreaLabel(areaName)}
                    </h3>
                    <p className="practice-area-percentage-practice-area">
                      {parseInt(details.percentage, 10)}%
                    </p>
                  </div>
                  <div className="practice-area-description-practice-area">
                    {isExpanded ? details.description : shortDescription}
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  >
                    <button
                      className="read-more-practice-area"
                      onClick={() => toggleExpand(areaName)}
                    >
                      {isExpanded ? "Less" : "... Read more"}
                    </button>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="case-section-container">
              <div className="work-case-container">
                <Timeline
                  align="left"
                  sx={{
                    "& .MuiTimelineItem-root:before": {
                      flex: 0,
                    },
                  }}
                >
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot color="grey" />
                      <div className="timeline-line" />
                    </TimelineSeparator>
                    <TimelineContent>
                      <div className="education-section-job-item">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            textAlign: "left",
                            marginLeft: "auto",
                            width: "60%",
                          }}
                        >
                          <p className="education-section-college">
                            No practice areas found.
                          </p>
                          <p className="education-section-description">
                            {/* Optionally add more placeholder text here */}
                          </p>
                        </div>
                      </div>
                    </TimelineContent>
                  </TimelineItem>
                </Timeline>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PracticeAreas;
